import React, {Component} from 'react';
import {View, TouchableWithoutFeedback, Image, StyleSheet, Text, findNodeHandle, UIManager} from 'react-native';
import {Modal} from 'qunar-react-native';
import {inject, observer,} from 'mobx-react/native';
import {observable,} from 'mobx';
import SizeUtil, {ScreenWidth} from "../../Utils/SizeUtil";
import QImageSet from '../../assets/QImageSet.js';
import RootStore from '../../Store';



interface Props {
    cardPostion: any,
    show: boolean,
    hiddenMoreButtonList: Function,
    cardData: any,
    clickCallBack: Function,
}

@inject((store: RootStore) => ({
    cardPostion: store.moreButtonStore.position,
    show: store.moreButtonStore.show,
    hiddenMoreButtonList: store.moreButtonStore.hiddenMoreButtonList,
    cardData: store.moreButtonStore.cardData,
    clickCallBack: store.moreButtonStore.clickCallBack,
}))
@observer
class MoreButtonList extends Component<Props> {

    @observable
    public modalTop = 0;

    public constructor(props:Props) {
        super(props);
    }

    public onButtonClick = (action) => {
        const {clickCallBack, hiddenMoreButtonList=()=>{}} = this.props;
        if (clickCallBack) {
            clickCallBack(action);   
        }

        hiddenMoreButtonList();

    }


    public render() {
        if (!this.props.show) return null;
        const {cardPostion = {},} = this.props;
        return (<Modal
            visible={this.props.show}
            maskOpacity={0} 
            style={{width: ScreenWidth, height: '100%'}}>
            <TouchableWithoutFeedback onPress={() => {
                this.props.hiddenMoreButtonList()
            }}>
                <View
                    ref={ref => this.ref = ref}
                    onLayout={() => {
                        const handle = findNodeHandle(this.ref);
                        UIManager.measureInWindow(handle, (x, y, width, height) => {
                            this.modalTop = y;
                        })
                    }}
                    style={{width: ScreenWidth, height: '100%',}}>
                    <View style={{
                        position: 'absolute',
                        width: (114),
                        left: (5),
                        top: cardPostion.y - this.modalTop + cardPostion.height / 2 + 2
                    }}>
                        {this._renderButtonList()}
                    </View>
                </View>
            </TouchableWithoutFeedback>
        </Modal>);
    }

    private _renderButtonList = () => {
        const {cardData} = this.props;
        if (!cardData || !cardData.buttonsToPop || cardData.buttonsToPop.length === 0) return null;
        const {buttonsToPop} = cardData;

        return (<View style={styles.listContainer}>
            <View style={{position: 'absolute', width: '100%', height: '100%'}}>
                <Image resizeMode={'stretch'} source={{uri: QImageSet.more_btn_list_top}} style={styles.topImg}/>
                <Image resizeMode={'stretch'} source={{uri: QImageSet.more_btn_list_center}} style={styles.centerImg}/>
                <Image resizeMode={'stretch'} source={{uri: QImageSet.more_btn_list_bottom}} style={styles.bottomImg}/>
            </View>
            <View style={styles.list}>
                {buttonsToPop.map((buttonData, index) => {
                    return this._renderButtonItem(buttonData, index < buttonsToPop.length - 1);
                })}
            </View>
        </View>)
    }

    private _renderButtonItem = (buttonData, needBottomLine) => {
        return (
            <TouchableWithoutFeedback onPress={() => {
                this.onButtonClick(buttonData);
            }}>
                <View style={[styles.buttonItem, needBottomLine ? {
                    borderBottomColor: '#EEEEEE',
                    borderBottomWidth: 0.5
                } : undefined]}>
                    <Text style={styles.buttonText}>{buttonData.title||""}</Text>
                </View>
            </TouchableWithoutFeedback>
        )
    }
}


const styles = StyleSheet.create({
    listContainer: {
        width: (114),
    },
    topImg: {
        height: (18),
        width: '100%',
    },
    bottomImg: {
        height: (22),
        width: '100%',
    },
    centerImg: {
        flex: 1,
        width: '100%',
    },
    list: {
        paddingTop: (11),
        paddingBottom: (12),
        width: '100%',
    },
    buttonItem: {
        height: (36),
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: (10),
    },
    buttonText: {
        fontSize: (13),
        color: '#616161',
    },
})

export default MoreButtonList;